import {
  Alert,
  Button,
  Classes,
  Dialog,
  Divider,
  FormGroup,
  H5,
  HTMLSelect,
  HTMLTable,
  InputGroup,
  NonIdealState,
  Popover,
  Tooltip,
} from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
  MDBTooltip,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { api } from "../../api";
import { IEmpresa, IUsuario } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import * as utils from "../../utils";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import Cookies from 'universal-cookie';
import { Pager } from "../utils/Pager";
import LoadingModal from "../loading/LoadingModal";
import { PermissaoMultiselect } from "../utils/PermissaoMultiselect";

const cookies = new Cookies()
const numeral = require("numeral");
var debounce = require('lodash.debounce');

require("../../assets/css/components/EmpresasPage.css");

interface State {
  listEmpresas: any;
}

@observer
export default class EmpresasPage extends React.Component<{}, State> {

  obs = observable({
    importingEmpresa: false as boolean,
    createUser: false as boolean,
    editUser: false as boolean,
    listUsers: false as boolean,
    handleDisablePass: true as boolean,
    addEmpresa: false as boolean,
    id_empresa: null as IEmpresa,
    usuario: null as IUsuario,
    nome_user: "" as string,
    email_user: "" as string,
    senha_user: "" as string,
    permissao_user: [] as string[],
    cnpj: "" as string,
    fetchOptions: {} as any,

  })

  constructor(props: {}) {
    super(props);

    this.obs.fetchOptions = debounce(this.handlePageChange.bind(this), 800);

    this.state = {
      listEmpresas: []
    }
  }

  componentDidMount(): void {
    AppStore.setTitle("Empresas");

    this.handleLoadEmpresas()
    EmpresaStore.count_empresas()

    EmpresaStore.usuariosEmpresas();

    this.setState({ listEmpresas: [] });

  }

  cancelarOperacao = () => {
    this.obs.createUser = false;
    this.obs.listUsers = false;
    this.obs.editUser = false;
    EmpresaStore.obs.confirmarAlert = false;
  };

  cancelarOperacaoEdit = () => {
    this.obs.editUser = false;

    this.obs.usuario = null
    this.obs.nome_user = ""
    this.obs.senha_user = ""
    this.obs.email_user = ""
    this.obs.permissao_user = []

    this.setState({ listEmpresas: [] });

  };

  cancelarOperacaoCreate = () => {
    this.obs.createUser = false;

    this.obs.usuario = null
    this.obs.nome_user = ""
    this.obs.senha_user = ""
    this.obs.email_user = ""
    this.obs.permissao_user = []

    this.setState({ listEmpresas: [] });

  };

  handleEditUser(usuario: IUsuario) {

    this.obs.usuario = usuario;
    this.obs.nome_user = usuario.nome_completo;
    this.obs.email_user = usuario.email;
    this.obs.permissao_user = usuario.permissao;

    let itens = EmpresaStore.obs.empresas_all.filter(emp => usuario.filiais.includes(emp._id)).map(emp => emp.cnpj)

    this.setState({ listEmpresas: itens })

    this.obs.editUser = true;

  }

  handleNotCreate() {
    toast.error('Você tem permissão para criar somente uma empresa no período de testes.', {});
  }

  handleCreateUser() {
    AppStore.setLocation("/usuarios-empresas");
  }

  handlePageChange = async (page: number) => {

    EmpresaStore.obs.currentPageEmp = page

    await EmpresaStore.load_empresas_filter(page, EmpresaStore.obs.filter, EmpresaStore.obs.certificado, EmpresaStore.obs.status);

  };

  handleLoadEmpresas = async () => {

    EmpresaStore.obs.currentPageEmp = 1
    EmpresaStore.obs.filter = ""

    await EmpresaStore.load_empresas_filter(1, EmpresaStore.obs.filter, EmpresaStore.obs.certificado, EmpresaStore.obs.status);

  };

  handleCertificateChange = async (certificado: string) => {

    EmpresaStore.obs.currentPageEmp = 1
    EmpresaStore.obs.filter = ""
    EmpresaStore.obs.certificado = certificado

    await EmpresaStore.load_empresas_filter(1, EmpresaStore.obs.filter, certificado, EmpresaStore.obs.status);

  };

  handleStatusChange = async (status: string) => {

    EmpresaStore.obs.currentPageEmp = 1
    EmpresaStore.obs.filter = ""
    EmpresaStore.obs.status = status

    await EmpresaStore.load_empresas_filter(1, EmpresaStore.obs.filter, EmpresaStore.obs.certificado, status);

  };

  handleSaveUser = async () => {

    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    if (!this.obs.nome_user) {
      toast.error('Preencha o nome do usuário', {});
      return;
    }

    if (!this.obs.email_user) {
      toast.error('Preencha o email do usuário', {});
      return;
    }

    if (!regex.test(this.obs.email_user)) {
      toast.warning("E-mail inválido!", {});
      return;
    }

    if (!this.obs.senha_user) {
      toast.error('Preencha a senha do usuário', {});
      return;
    }

    if (!this.obs.permissao_user) {
      toast.error('Selecione as permissões do usuário', {});
      return;
    }

    if (this.state.listEmpresas.length < 1) {
      toast.error('Selecione pelo menos uma empresa do usuário', {});
      return;
    }

    let params = {
      "nome_user": this.obs.nome_user,
      "email_user": this.obs.email_user,
      "senha_user": this.obs.senha_user,
      "permissao_user": this.obs.permissao_user,
      "list": this.state.listEmpresas,
    }

    await EmpresaStore.handleCreateUser(params)

    this.obs.createUser = false;
    this.cancelarOperacaoCreate()

  };

  handleUpdateUser = async () => {

    var senha = null;

    if (!this.obs.handleDisablePass) {
      senha = this.obs.senha_user;
    } else {
      senha = null;
    }

    if (!this.obs.nome_user) {
      toast.error('Preencha o nome do usuário', {});
      return;
    }

    if (!this.obs.email_user) {
      toast.error('Preencha o email do usuário', {});
      return;
    }

    if (!this.obs.permissao_user) {
      toast.error('Selecione as permissões do usuário', {});
      return;
    }

    if (this.state.listEmpresas.length < 1) {
      toast.error('Selecione pelo menos uma empresa do usuário', {});
      return;
    }

    let params = {
      "nome_user": this.obs.nome_user,
      "senha_user": senha,
      "email_user": this.obs.email_user,
      "permissao_user": this.obs.permissao_user,
      "list": this.state.listEmpresas
    }

    await EmpresaStore.handleUpdateUser(params)

    this.obs.editUser = false;
    this.cancelarOperacaoEdit()

  };

  handleCheckEmpresaChange = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listEmpresas.push(row.cnpj) });

    } else {

      let index = this.state.listEmpresas.indexOf(row.cnpj);

      this.state.listEmpresas.splice(index, 1);

    }

  };

  handleCheckEmpresas = async (check, row) => {

    if (check) {

      this.setState({ listEmpresas: row?.map(value => value.cnpj) });

    } else {

      this.setState({ listEmpresas: [] });
    }

  };

  async handleDeletaUsuario(usu) {

    await EmpresaStore.handleDeletaUsuario(usu)

  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  handleEmpresasFilter = (e) => {

    EmpresaStore.obs.filter = e

    this.obs.fetchOptions(1)

  };

  handleMultiSelectChange = (selected: string[]) => {

    this.obs.permissao_user = selected

  };

  renderData() {

    const startDate = moment().toDate();

    let dataHoje = moment(startDate).format("YYYY-MM-DD");

    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    let rows = EmpresaStore.obs.empresas?.map(emp => {
      return (
        {
          id: emp._id,
          cipher_id: emp.cipher_id,
          certificado: emp.certificado,
          razao_social: emp.razao_social,
          cnpj: utils.formatCnpj(emp.cnpj),
          regime: emp.regime_importacao,
          simples_nacional: emp.simples_nacional,
          valor_calculado: emp.valor_calculado,
          valor_calculado_saida: emp.valor_calculado_saida,
          plano_id: emp.plano_id,
          ativo: emp.ativo,
          plano: emp.plano,
          apelido: emp.apelido
        }
      );
    },
    );

    let usuarios = EmpresaStore.obs.usuarios_emp?.map(usu => {
      return (
        <tr key={usu.id} className="nz-table-actions">
          <td>
            {usu.nome_completo}
          </td>
          <td>{usu.email}</td>
          {/* <td>{usu.permissao.join()}</td> */}
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEditUser.bind(this, usu)}
            >
              <img src="/images/edit.png" width={25} />
            </MDBBtn>
            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/bin.png" width={25} />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <p>Confirmar exclusão do usuário?</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleDeletaUsuario(usu)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    function handleEdit(row) {
      AppStore.setLocation(`/empresa/edit/${row.id}`);
    }

    function handleDeleteConfirm(row) {
      return EmpresaStore.handleDeleteConfirm(row);
    }

    async function handleDeleteEmpresa(row) {
      EmpresaStore.obs.title_loading = "Excluindo empresa!"
      await EmpresaStore.handleDeleteEmpresa(row);

    }

    function buttonFormatter(cell, row) {
      return (
        <>
          {row.ativo && (
            <MDBBtn
              color="default"
              rounded
              size="sm"
              disabled={niveis_acesso.indexOf("e2") == -1}
              onClick={(e) => handleEdit(row)}
            >
              <img src="/images/edit.png" width="25px" />
            </MDBBtn>
          )}
          {AppStore.obs1.usuario.representante && row.ativo ?
            <>
              <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                <MDBBtn
                  color="default"
                  rounded
                  size="sm"
                >
                  <img src="/images/bin.png" width={25} />
                </MDBBtn>
                <div>
                  <H5>Confirmar exclusão</H5>

                  <p style={{ fontSize: 12 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 15,
                    }}
                  >
                    <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                      Cancelar
                    </Button>

                    <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={(e) => handleDeleteEmpresa(row)}>
                      Excluir
                    </Button>
                  </div>
                </div>
              </Popover>
            </>

            :
            <>
              {row.ativo && !AppStore.obs1.usuario.conta.teste &&
                (
                  <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                    <MDBBtn
                      color="default"
                      rounded
                      size="sm"
                    >
                      <img src="/images/block.png" width={25} />
                    </MDBBtn>
                    <div>
                      <H5>Desativar Empresa?</H5>
                      <p>Você confirma desativar a empresa: {row.razao_social}?</p>
                      <p>
                        Ao desativar, os dados ficarão salvos durante 3 (três) meses, mas o CNPJ não
                        estará mais operante para calculos e manifestações.
                      </p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: 15,
                        }}
                      >
                        <Button
                          className={Classes.POPOVER_DISMISS}
                          style={{ marginRight: 10 }}
                        >
                          Cancelar
                        </Button>
                        <Button
                          intent="danger"
                          className={Classes.POPOVER_DISMISS}
                          onClick={(e) => handleDeleteConfirm(row)}
                          disabled={niveis_acesso.indexOf("e3") == -1}
                        >
                          Desativar
                        </Button>
                      </div>
                    </div>
                  </Popover>
                )}
            </>
          }
        </>
      );
    }

    function ativaFormatter(cell, row) {
      return (
        <>
          {row.ativo
            ? (
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/checked.png" width="25px" />
              </MDBBtn>
            )
            : (
              <MDBBtn color="default" rounded size="sm">
                <img src="/images/block.png" width="25px" />
              </MDBBtn>
            )}
        </>
      );
    }

    function certificadoFormat(cell, row) {
      let textCertificado = <></>;
      if (row.certificado) {
        const timeStart = moment(startDate);
        const timeEnd = moment(row.certificado);
        const diff = timeEnd.diff(timeStart);
        if (moment(row.certificado).format("DD/MM/YYYY") == "Invalid date") {
          textCertificado = <span>Processando...</span>;
        } else {
          if (row.certificado <= dataHoje) {
            textCertificado = (
              <b>
                <span>
                  Expirado (Val: {moment(row.certificado).format("DD/MM/YYYY")})
                </span>
              </b>
            );
          } else {
            textCertificado = (
              <b>
                Cadastrado (Val: {moment(row.certificado).format("DD/MM/YYYY")})
              </b>
            );
          }
        }
      } else {
        if (row.certificado != null) {
          textCertificado = <span>Processando...</span>;
        } else {
          textCertificado = <span>Sem Certificado Digital</span>;
        }
      }

      return textCertificado;
    }

    function faturamentoFormat(cell, row) {

      let entrada = row.valor_calculado ? row.valor_calculado.soma_entrada : 0

      let saida = row.valor_calculado ? row.valor_calculado.soma_saida : 0

      let valor = Math.max(entrada, saida)

      let plano = (row.plano || { "maximo": 0 }).maximo;

      let width: number = ((valor / plano) * 100);
      let color: string = width >= 90
        ? "vermelho"
        : width > 70 && width < 90
          ? "amarelo"
          : "verde";

      return (<>
        <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING} className="tooltip-empresas" interactionKind="hover-target" position="left">
          <div className={"progress-empresas bp3-progress-bar bp3-intent-primary bp3-" + color}>
            <div className="bp3-progress-meter"
              style={{ width: `${isNaN(width) ? 0 : width}%` }}>
            </div>
          </div>

          <span style={{ textAlign: "center", fontSize: 12 }}>
            No mês {moment().subtract(1, 'months').format("MM")}, foram calculados <br /> R$ {numeral(valor).format("0,0.00") || 0} de um total de <br /> R$ {numeral(plano).format("0,0.00")} contratado.
          </span>
        </Popover>
      </>
      );
    }

    const options_soli = {
      searchField: this.createCustomSearchFieldSol,
    };

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckEmpresaChange,
      onSelectAll: this.handleCheckEmpresas,
      selected: this.state.listEmpresas,
    };

    let empresasUser = EmpresaStore.obs.empresas_all?.map(map_emp => {

      let emp = EmpresaStore.getByCnpj(map_emp.cnpj);

      if (emp && emp.ativo) {

        return ({
          _id: emp._id,
          razao_social: emp.razao_social,
          cnpj: emp.cnpj,
          cnpj_formated: utils.formatCnpj(emp.cnpj)
        })

      }

    });

    return (
      <div className="empresas-page">

        <LoadingModal open={EmpresaStore.obs.waitEmpresas} onClose={() => EmpresaStore.obs.waitEmpresas = false} title={"Buscando empresas"} />
        <LoadingModal open={EmpresaStore.obs.loading} onClose={() => EmpresaStore.obs.loading = false} title={EmpresaStore.obs.title_loading} />

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.listUsers}
          onConfirm={() => this.cancelarOperacao()}
          onClose={() => this.cancelarOperacao()}
          canOutsideClickCancel={true}
          className="alertUsuariosConta"
        >
          <h2 className="titleSEFAZ">Usuários</h2>
          <MDBBtn
            className="btnDefault"
            style={{ marginBottom: 20 }}
            onClick={(e) => this.obs.createUser = true}
            disabled={niveis_acesso.indexOf("e1") == -1}
          >
            Adicionar Usuário
          </MDBBtn>
          <div style={{ width: "100%", height: 400, overflow: "auto", padding: 10 }}>
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 200 }}>Nome</th>
                  <th style={{ width: 200 }}>E-mail</th>
                  {/* <th style={{ width: 250 }}>Permissão</th> */}
                  <th style={{ width: 120 }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {usuarios}
              </tbody>
            </HTMLTable>
          </div>
        </Alert>
        <Alert
          confirmButtonText="Confirmar Desativação"
          cancelButtonText="Cancelar"
          isOpen={EmpresaStore.obs.confirmarAlert}
          onClose={() => this.cancelarOperacao()}
          onConfirm={() => EmpresaStore.handleDeleteEmp()}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Deseja realmente desativar?</h2>
          <p>
            Ao desativar essa empresa, você estará ciente de que não haverá mais
            possibilidade de calcular e manifestar NF-es.
          </p>
        </Alert>

        <Dialog
            isOpen={this.obs.createUser}
            onClose={() => this.cancelarOperacaoCreate()}
            className="AlertUser"
        >
          <h2 className="titleSEFAZ">Adicione um usuário para uma empresa</h2>

          <div style={{ display: "flex" }}>

            <FormGroup
              label="Nome completo"
              labelFor="nome-completo"
              labelInfo="(obrigatório)"
              style={{ width: "50%" }}
            >
              <InputGroup
                id="nome-completo"
                onChange={(e: any) => this.obs.nome_user = e.target.value}
              />
            </FormGroup>

            &nbsp;&nbsp;

            <FormGroup
              label="E-mail"
              labelFor="email"
              style={{ width: "50%" }}
            >
              <InputGroup
                id="email"
                name='new-email'
                autoComplete='new-email'
                onChange={(e: any) => this.obs.email_user = e.target.value}
              />
            </FormGroup>

          </div>

          <FormGroup
            label="Senha"
            labelFor="senha"
          >
            <InputGroup
              id="senha"
              type="password"
              name='new-password'
              autoComplete='new-password'
              onChange={(e: any) => this.obs.senha_user = e.target.value}
            />
          </FormGroup>

          <FormGroup
            label="Permissão"
            labelFor="permissao"
          >
            <PermissaoMultiselect onChange={this.handleMultiSelectChange.bind(this)} value={this.obs.permissao_user} />
          </FormGroup>

          <FormGroup label="Selecione as Empresas" labelFor="empresas">
            <div className="select-empresa-sefa">
              <BootstrapTable data={empresasUser} selectRow={selectRowProp} options={options_soli} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="75%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.cancelarOperacaoCreate()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleSaveUser()} />
          </div>

        </Dialog>

        <Dialog
            isOpen={this.obs.editUser}
            onClose={() => this.cancelarOperacaoEdit()}
            className="AlertUser"
        >
          <h2 className="titleSEFAZ">Editar Usuário</h2>
          {this.obs.usuario &&
            (
              <>
                <div style={{ display: "flex" }}>

                  <FormGroup label="Nome completo" labelFor="nome-completo" labelInfo="(obrigatório)" style={{ width: "50%" }}>
                    <InputGroup
                      id="nome-completo"
                      defaultValue={this.obs.usuario.nome_completo}
                      onChange={(e: any) => this.obs.nome_user = e.target.value}
                    />
                  </FormGroup>

                  &nbsp;&nbsp;

                  <FormGroup label="E-mail" labelFor="email" style={{ width: "50%" }}>
                    <InputGroup
                      id="email"
                      name='new-email'
                      autoComplete='new-email'
                      defaultValue={this.obs.usuario.email}
                      disabled={true}
                      onChange={(e: any) => this.obs.email_user = e.target.value}
                    />
                  </FormGroup>

                </div>

                <FormGroup
                  label="Senha"
                  labelFor="senha"
                >
                  <MDBRow>
                    <MDBCol xl="10" md="10" sm="10" xs="10">
                      <InputGroup
                        name='new-password'
                        autoComplete='new-password'
                        id="senha"
                        type="password"
                        disabled={this.obs.handleDisablePass}
                        onChange={(e: any) => this.obs.senha_user = e.target.value}
                      />
                    </MDBCol>
                    <MDBCol xl="2" md="2" sm="2" xs="2">
                      <MDBBtn
                        color="default"
                        rounded
                        size="sm"
                        onClick={(e) => this.obs.handleDisablePass = false}
                      >
                        <img src="/images/edit.png" style={{ marginTop: 6 }} />
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </FormGroup>

                <FormGroup
                  label="Permissão"
                  labelFor="permissao"
                >
                  <PermissaoMultiselect onChange={this.handleMultiSelectChange.bind(this)} value={this.obs.permissao_user} />
                </FormGroup>

                <FormGroup label="Selecione as Empresas" labelFor="empresas">
                  <div className="select-empresa-sefa">
                    <BootstrapTable data={empresasUser} selectRow={selectRowProp} options={options_soli} search>
                      <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
                      <TableHeaderColumn dataField="razao_social" width="75%">Razão Social</TableHeaderColumn>
                      <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
                    </BootstrapTable>
                  </div>
                </FormGroup>
              </>
            )}

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.cancelarOperacaoEdit()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleUpdateUser()} />
          </div>

        </Dialog>

        <MDBRow>
          <FormGroup label="&nbsp;" style={{ width: 500, marginLeft: 15 }}>
            <InputGroup
              style={{ borderRadius: "10px" }}
              placeholder="Filtrar (Razão Social, CNPJ)"
              value={EmpresaStore.obs.filter}
              onChange={(e) => this.handleEmpresasFilter(e.target.value)}
            />
          </FormGroup>

          <FormGroup label="Status Certificado" style={{ width: 220, marginLeft: 15 }}>
            <HTMLSelect onChange={(e) => this.handleCertificateChange(e.target.value)} value={EmpresaStore.obs.certificado} style={{ width: 220 }}>
              <option value="">Todos</option>
              <option value="0">Sem Certificado</option>
              <option value="1">Expirado</option>
              <option value="2">Em vigência</option>
            </HTMLSelect>
          </FormGroup>

          <FormGroup label="Status Empresa" style={{ width: 220, marginLeft: 15 }}>
            <HTMLSelect onChange={(e) => this.handleStatusChange(e.target.value)} value={EmpresaStore.obs.status} style={{ width: 220 }}>
              <option value="">Todos</option>
              <option value="1">Ativas</option>
              <option value="0">Inativas</option>
            </HTMLSelect>
          </FormGroup>

          <MDBCol className="inputFilter">
            <Button
              style={{ float: "right" }}
              icon="export"
              className="btnRoxo "
              onClick={() => EmpresaStore.handleExport()}
              loading={EmpresaStore.obs.loading_export}
            >
              Exportar Empresas
            </Button>
          </MDBCol>
        </MDBRow>

        <BootstrapTable
          className="TableDefault empresaTable"
          ref="table"
          data={rows}
          hover
        >
          <TableHeaderColumn dataField="cipher_id" isKey={true} hidden>#</TableHeaderColumn>
          <TableHeaderColumn dataField="plano" hidden>#</TableHeaderColumn>
          <TableHeaderColumn dataField="certificado" hidden>#</TableHeaderColumn>
          <TableHeaderColumn dataField="razao_social" width="35%">Razão Social</TableHeaderColumn>
          {/* <TableHeaderColumn dataField="apelido" width="30%">Apelido</TableHeaderColumn> */}
          <TableHeaderColumn dataField="cnpj" width="15%">CNPJ</TableHeaderColumn>
          <TableHeaderColumn dataField="regime" width="10%">Regime</TableHeaderColumn>
          <TableHeaderColumn dataFormat={faturamentoFormat} width="20%">Faturamento Plano</TableHeaderColumn>
          <TableHeaderColumn dataFormat={certificadoFormat} width="15%">Certificado</TableHeaderColumn>
          <TableHeaderColumn dataFormat={buttonFormatter} width="10%">Ações</TableHeaderColumn>
          <TableHeaderColumn dataFormat={ativaFormatter} width="5%">Ativa</TableHeaderColumn>
        </BootstrapTable>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={EmpresaStore.obs.currentPageEmp}
            totalCount={EmpresaStore.obs.length_empresas}
            pageSize={10}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>
      </div>
    );
  }

  renderNonIdeal() {
    let action = (
      <div>
        <MDBBtn className="btnDefault" onClick={this.handleCreate}>
          Criar Empresa
        </MDBBtn>
      </div>
    );

    return (
      <div className="nz-non-ideal">
        <NonIdealState icon="box" title="Não há registros" action={action} />
      </div>
    );
  }

  handleCreate = () => {
    AppStore.setLocation("/empresa/plan");
  };

  handleImportClose = () => {
    this.obs.importingEmpresa = false;
  };

  render() {
    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];

    return (
      <>
        <div className="nz-toolbar">
          {contaPermissao ?
            (
              <>
                {EmpresaStore.obs.count_empresas < 1 ?
                  <MDBBtn className="btnDefault" onClick={this.handleCreate}>Criar Empresa</MDBBtn>
                  :
                  <MDBBtn className="btnDefault" onClick={this.handleNotCreate}>Criar Empresa</MDBBtn>
                }
              </>
            )
            : (
              <>
                <MDBBtn
                  className="btnDefault"
                  onClick={this.handleCreate}
                  disabled={niveis_acesso.indexOf("e1") == -1}
                >
                  Adicionar Empresa
                </MDBBtn>
                <MDBBtn
                  className="btnDefault btn-usuarios-empresas"
                  style={{ marginLeft: 20 }}
                  onClick={(e) => this.obs.listUsers = true}
                  disabled={niveis_acesso.indexOf("e1") == -1}
                >
                  Usuários das Empresas
                </MDBBtn>
              </>
            )}

          <div style={{ flexGrow: 1 }} />
        </div>
        {this.renderData()}
      </>
    );
  }

}
